import type { ProviderHealth, ProviderRole, QueueName, ReplayOutcome } from '@rp/contracts'

export const OPERATIONS_COPY = {
  title: '營運狀況',
  forbidden: '只有管理員可以看這一頁',
  forbiddenBody: '請回到佇列繼續處理你的項目。',
  slaTitle: '回覆期限',
  slaLoading: '正在整理回覆期限…',
  slaEmpty: '目前沒有接近期限的對話，很好。',
  slaAtRisk: '快到期限',
  slaBreached: '已超過期限',
  slaAtRiskList: '快到期限，仍可及時回覆',
  slaBreachedList: '已超過期限，仍未回覆',
  slaAtRiskEmpty: '目前沒有快到期限的對話。',
  slaBreachedEmpty: '目前沒有逾期未回覆的對話。',
  slaLoadFailed: '未能讀取這份清單，請稍後再試',
  slaSummary: (atRisk: number, breached: number) => `${breached} 則已超過期限，${atRisk} 則快到期限`,
  slaPager: (list: string) => `${list}分頁`,
  pageStatus: (page: number, pages: number, total: number) => `第 ${page} / ${pages} 頁・共 ${total} 則`,
  providerTitle: 'AI 服務狀態',
  providerLoading: '正在讀取 AI 服務狀態…',
  answering: (provider: string) => `目前由 ${provider} 回答分類和建議`,
  nobodyAnswering: '目前沒有可用的 AI provider，新的分類和建議會失敗，請先不要重送失敗的工作',
  classifyingAndDrafting: (classifier: string, drafter: string) => `目前由 ${classifier} 分類、由 ${drafter} 產生建議`,
  draftingDown: (classifier: string) =>
    `分類仍由 ${classifier} 處理；目前沒有可用的聊天 provider，新的建議會失敗，請先不要重送失敗的建議工作`,
  lastFailure: (time: string, count: number) => `最近一次失敗：${time}（連續 ${count} 次）`,
  probeAfter: (time: string) => `${time} 後會試探是否恢復`,
  deadLetterTitle: '失敗的背景工作',
  deadLetterLoading: '正在讀取失敗的背景工作…',
  deadLetterEmpty: '目前沒有失敗的背景工作。',
  deadLetterSummary: (total: number) => `共 ${total} 筆`,
  queue: '工作類型',
  failedAt: '失敗時間',
  retryCount: '已重試次數',
  replay: '重送',
  replaying: '重送中…',
  replayed: '已重送',
  replayedAt: '重送時間',
  replayedNote: (time: string, outcome: string | null) => (outcome === null ? `已重送：${time}` : `已重送：${time}・${outcome}`),
  replayRepeat: '這筆是重送後再次失敗',
  openItem: '查看對話',
} as const

export const PROVIDER_HEALTH_COPY: Record<ProviderHealth, string> = {
  healthy: '正常',
  failing: '開始出錯',
  circuit_open: '已暫停使用',
  recovering: '正在試探恢復',
}

export const PROVIDER_ROLE_COPY: Record<ProviderRole, string> = {
  primary: '主要',
  secondary: '備援',
  decision: '分類（決策）',
}

export const REPLAY_OUTCOME_COPY: Record<ReplayOutcome, string> = {
  pending: '重送了，正在等待結果',
  succeeded: '重送成功',
  failed: '重送後再次失敗，新的失敗紀錄在列表中',
  unknown: '重送結果已無紀錄',
}

export const QUEUE_LABELS: Record<QueueName, string> = {
  'classify-conversation': '分類對話',
  'refetch-meta-object': '向 Meta 取回內容',
  'fetch-post': '取得留言所在的貼文',
  'generate-suggestion': '產生建議草稿',
  'ingest-kb-source': '匯入知識來源',
  'retire-corpus-for-source': '停用知識來源的回覆範例',
  'check-channel-health': '檢查粉專連線',
  'sweep-channel-health': '定時檢查粉專連線',
  'sweep-inbound-outbox': '補送收到的訊息',
  'sweep-stranded-replies': '檢查未完成的回覆',
  'sweep-auto-suggestion-outbox': '補送自動建議',
  'sla-sweep': '回覆期限檢查',
  'redact-expired': '遮蔽過期內容',
  'prune-auth-state': '清理過期登入紀錄',
  'notify-inbox': '推送新訊息通知',
}
